import React, { useState, useEffect, useRef }  from 'react';
import { ContentPopup } from 'components/ContentPopup.jsx';
import { GetRequest } from 'components/common/index.js';
import { PricingTables, PaymentForm } from 'components/payment/index.js';
import PaymentSuccess from 'components/pricing/PaymentSuccess.jsx';
import LogInRequired from 'components/pricing/LogInRequired.jsx';
import { getStartedPriceLabel } from 'components/pricing/getStartedPriceLabel';

// Where each API's free tier sends the visitor after "Get started": the Dielines API to its
// getting-started blog post, the Dieline Dimensions API to its landing page's live try-it viewer.
const FREE_TIER_URLS = {
  dielines_api_free: '/blog/dielines-api-how-to-create-custom-dielines-and-3d-mockups',
  dimensions_api_free: '/dieline-dimensions-api#try-it',
};

const BuySubscriptionButton = ({ type, subscription_type, cta, seatSelect, priceValue, priceCadence, tierKey }) => {
  const freeTierUrl = () => FREE_TIER_URLS[subscriptionType()];

  const handleClick = (e) => {
    if(e != undefined) {  e.preventDefault() }
    trackEvent('buy_subscription_button_clicked',  { cta: cta });

    if (freeTierUrl()) {
      if (window.currentUserEmail) {
        window.location.href = freeTierUrl();
      } else {
        // popupContent gates LogInRequired on subscription != undefined; for the
        // free flow there is no real subscription, so set a placeholder so the
        // login/signup UI renders instead of the loading spinner
        setSubscription(() => ({ free_tier: true }));
        setMode(() => 'log_in_required');
        setShowPopUp(() => true);
      }
      return;
    }

    setShowPopUp( () => true );
    fetchSubscription();
  }

  const redirectToFreeTier = () => { window.location.href = freeTierUrl(); }

  const subscriptionType = () => {
    if(type == 'credits') { return $('input[name="credit_subscription_type"]:checked').val(); }
    if(type == 'dielines_api_credits') { return $('input[name="api_credit_subscription_type"]:checked').val(); }
    if(type == 'dielines_api_monthly') { return $('input[name="api_subscription_type"]:checked').val(); }
    // Multi-seat tiers: read the card's seat dropdown and buy the _for_N bundle.
    if(seatSelect) {
      const seats = parseInt($(`#${seatSelect}`).val() || '1', 10);
      return seats > 1 ? `${type}_for_${seats}` : type;
    }
    return type;
  }

  const loadingIcon = () => { return (<><img src={window.loading_icon} /> <br /> <br /></>) }
  const fetchSubscription = () => {
    GetRequest({
      url: '/charge/subscriptions',
      callback: (data) => {
        setCurrencyName(data.currency_name)
        setSubscription( (_prev) => data[subscriptionType()] )

        if(data.logged_in) {
          setMode(() => 'payment_form')
        } else {
          setPromptForCreateAccountEmail( () => data.omniauth_email )
          setMode(() => 'log_in_required')
        }
        window.drawingUrl = `/pricing?subscription_type=${subscriptionType()}`
      }
    })
  }
  useEffect(() => {
    if(subscription_type != undefined && subscription_type != '' && subscriptionType() == subscription_type) {
      handleClick()
    }
  }, [])

  const [showPopUp, setShowPopUp] = useState(false);
  const [mode, setMode] = useState('loading');
  const popupRef = useRef();

  const [subscription, setSubscription] = useState(undefined)
  const [currencyName, setCurrencyName] = useState('')
  const [promptForCreateAccountEmail, setPromptForCreateAccountEmail] = useState('')
  // The total charged for this plan (e.g. "$120"), shown on the button so the
  // billing amount and cadence are explicit at the point of click. For annual
  // multi-seat cards this changes when a different user count is picked, so we
  // seed it from the prop and update it from the seat-picker's event below.
  const [price, setPrice] = useState(priceValue)

  // Keep the button's price in sync with the card's multi-seat picker (annual
  // tier cards only). The picker dispatches a `tier_seat_changed` event carrying
  // the newly-selected bundle's total; each button updates only if it matches
  // its own tier. Storing it in React state (rather than mutating the DOM) means
  // the correct total survives the component's re-renders.
  useEffect(() => {
    if (!seatSelect || !tierKey) { return undefined; }
    const handler = (event) => {
      if (event.detail && event.detail.tierKey === tierKey && event.detail.total) {
        setPrice(event.detail.total);
      }
    };
    document.addEventListener('tier_seat_changed', handler);
    return () => { document.removeEventListener('tier_seat_changed', handler); };
  }, [])

  // "Get Started — $120/year" when a price is supplied, otherwise the plain
  // label (credits / API flows pass no price).
  const buttonLabel = () => {
    if (!price) { return t('sign_up.get_started'); }
    return getStartedPriceLabel(priceCadence, price);
  }

  const popupContent = () => {
    let callback = () => {
      popupRef.current.style.display = "none";
      setShowPopUp(() => false);
    };

    let content = (
      <>
      {subscription == undefined && <>{loadingIcon()}</> }
      {subscription != undefined && <div className="testimonials-block preview-promo-block">
        <div className="testimonials-desc">
           {mode == 'payment_form' && <PaymentForm setMode={setMode} subscription={subscription} setSubscription={setSubscription} setCurrencyName={setCurrencyName}/> }
           {mode == 'payment_success' && <PaymentSuccess subscription={subscription} /> }
           {mode == 'log_in_required' && <LogInRequired mode={mode} setMode={setMode} promptForCreateAccountEmail={promptForCreateAccountEmail} callback={freeTierUrl() ? redirectToFreeTier : fetchSubscription} autoOpen={true} /> }
        </div>
      </div>}
    </>)

    return <ContentPopup
      contextClass="wrapper"
      myRef={popupRef}
      autoOpen={true}
      content={content}
      cancelButton={false}
      beforeClose={callback}
      notWide={true}
    />;
  }
  return (
    <span>
      <center>
        <a className="btn btn-price simple-btn" onClick={handleClick} > { buttonLabel() } </a>
      </center>
      {showPopUp && popupContent()}
    </span>
  )
}

export default BuySubscriptionButton;